import { ChangeDetectorRef, Component, ElementRef, Input, Output, EventEmitter, Inject } from "@angular/core";
import { FnolService } from "../../services/fnol.service";
import {
  FNOL_COUNTRY,
  FNOL_STEPS,
  DISPLAY_MESSAGES,
  MARINE_FILE_ALLOWED_FORMAT,
  UPLOADTEXT,
  UtilsConstLabelsLocalization,
  TRANSLATION_COUNTRY, COUNTRIES_WITH_EXTRA_BANNER_IN_UPLOAD,
  ALERT_FOR_NO_UPLOAD,
  FULL_LIST_EXTRA_MSG,
  FILEFORMATERRORMSG
} from "../../config/fnol-constants";
import {
  FNOL_STEPS_LITE,
  UtilsConstLITELabelsRetrieve,
} from "../../config/fnol-sg-constants";
import { URL_PARAMETERS } from "../../config/urlParameters.constant";
import { FnolModelService } from "../../services/fnol-model.service";
import { LoadingService } from "axis-components";
import { BehaviorSubject } from "rxjs";
import { DataStoreService } from "../../services/data-store.service";
import { CommonUtils } from "../../shared/utils/common-utils";
import moment from 'moment';;
import { AppConfig } from "src/app/shared/config";
import { CacheService } from "src/app/shared/services/cache.service";
import { CdpLiteModelService } from "../../cdp-lite/cdp-lite/services/cdp-lite-model.service";
import { CommonCdpLiteApiService } from "../../cdp-lite/cdp-lite/services/common-cdp-lite-api.service";
import { alertVisible } from "../../config/fnol-upload-constants";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: "axis-custom-file-upload",
  styles: [
    `
      .axis-img-zoom {
        position: relative;
      }
      .axis-img-zoom img {
        height: auto;
        left: 100%;
        max-width: 400%;
        position: absolute;
        transform: translate(0, -100%);
      }

      .axis-upload-wrapper tbody td {
        vertical-align: middle;
      }

      .axis-upload-wrapper tr.row-danger > td {
        animation: fade-danger 2s linear;
      }
      axis-alert a span.link {
        color: #ffffff;
        text-decoration: underline;
        font-weight: 600;
      }
      @keyframes fade-danger {
        0%,
        100% {
          background-color: transparent;
        }
        30%,
        60% {
          background-color: #fbe7eb;
        }
      }
      .axis-upload-wrapper tr.row-success > td {
        animation: fade-success 2s linear;
      }
      @keyframes fade-success {
        0%,
        100% {
          background-color: transparent;
        }
        30%,
        60% {
          background-color: #bdf0df;
        }
      }
      .axis-upload-wrapper tr.row-muted > td {
        background-color: #fafafa;
      }
    `,
  ],
  templateUrl: "./custom-file-upload.component.html",
})
export class FileUploadCustomComponent {
  /* properties */

  @Input() item;
  @Input() closeAction;
  @Output() messageEvent = new EventEmitter<string>();
  @Output() uploadSucces = new EventEmitter<Boolean>();
  public customEvent: BehaviorSubject<any>;
  claimBenefit: string;
  editMultipleFields = false;
  claimNumberGenerated: string;
  docIdGenerated: string;
  fileLoading = false;
  fileToDelete;
  fileToEdit;
  fullListMsg = "";
  dateVal;
  fileUploading = "";
  fileFormatMsg;
  country: string;
  dropDownLabel: string;
  typePlaceholder: string;
  messageError: string;
  growlDelay = 10; // 10s
  imagePreview = true;
  isMulti = true;
  supportLink;  
  //   afterUploadButtonText = "Browse to Upload";
  afterUploadButtonText = $localize`:@@documents.browseToUpload:Browse to Upload`;
  restrictFiles = "";
  uploadErrors: number;
  uploadErrorsList = [];
  uploadFileProgress = 0;
  uploadProgress;
  uploadRenameEmpty = [];
  apiFailure: string;
  deleteFailure: string;
  docIdList = [];
  uploadRecords = [
    12, 35, 54, 22, 47, 39, 29, 18, 9, 22, 32, 49, 28, 51, 39, 19,
  ];
  uploadSelected = [];
  uploadSelectedInitial = [];
  uploaded = [];
  userName = "";
  fileUploadFailed = false;
  uploadText = null;
  supportingDocumentType;
  readonly FNOL_COUNTRY = FNOL_COUNTRY;
  readonly URL_PARAMETERS = URL_PARAMETERS;
  readonly isCountryAuOrNz = CommonUtils.isCountryAuOrNz;
  public claimBenefitTypes = [];
  uploadDocumentModel: any;
  errorMessage = false;
  zeroByteError = false;
  exceedSizeError = false;
  deleteFailedError = false;
  formatUnsupportedError = false;
  zeroByteErrorMsg;
  exceedSizeErrorMsg;
  formatUnsupportedErrorMsg;
  isNam = false;
  namSelectedClaimType;
  claimType;
  claimTypeChangedError = false;
  language = '';
  country_cacheService = '';
  updateStatus;
  updateMsg;
  uploadSizeCount = 0;
  uploadSumErrorSize = false;
  uploadSumErrorSizeMsg;
  isAlertVisible: boolean = false;
  uploadNotRequire = ALERT_FOR_NO_UPLOAD['msg'];
  bannerForMedicalDocuments = COUNTRIES_WITH_EXTRA_BANNER_IN_UPLOAD.includes(this.cacheService.getCountry().toUpperCase())
  allSelectedFiles=0;
  constructor(
    private elRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private fnolService: FnolService,
    private fnolModelService: FnolModelService,
    private cacheService: CacheService,
    public loadingService: LoadingService,
    private _dataStoreService: DataStoreService,
    private cdpLiteModelService: CdpLiteModelService,
    private commonCdpLiteApiService: CommonCdpLiteApiService,
    @Inject(DOCUMENT) private document: Document
  ) {
    // prevented null pointer
    if (this.cacheService.get('language')) {
      this.language = this.cacheService.get('language').toLowerCase();
    }

    if (this.cacheService.get('country')) {
      this.country_cacheService = this.cacheService.get('country').toLowerCase();
    }

    if (
      URL_PARAMETERS.COUNTRY.toLowerCase() ===
      FNOL_COUNTRY.LITE.countryCode
    ) {
      this.uploadText = $localize`:@@documents.dragNdrop:<p>Drag and drop or <u>Browse</u> here to select the upload File.</p>
  <p data-color="gray" class="_text-small">Maximum file size for all uploads: 15 MB</p>`;
      if (UPLOADTEXT[this.cacheService.getCountry().toLowerCase()]) {
        this.uploadText = UPLOADTEXT[this.cacheService.getCountry().toLowerCase()].uploadText;
      }
      if (FULL_LIST_EXTRA_MSG.includes(this.cacheService.getCountry().toLowerCase())) {
        this.fullListMsg = $localize`:@@documents.listmsg:Document Type`;
      }

      const data = this._dataStoreService.get(FNOL_STEPS.UPLOAD_DOCS.name);
      if (data && data.uiData.customFileUpload?.uploads !== undefined) {
        this.uploaded = data.uiData.customFileUpload.uploads;
      }
      const liteSelectedClaimType = this._dataStoreService.get(
        FNOL_STEPS_LITE().list.CLAIM_TYPE_DETAILS.name
      ).uiData["claimBenefits"];
      this.claimBenefitTypes = UtilsConstLITELabelsRetrieve.getClaimBenefitTypes(
        liteSelectedClaimType
      );
    }
    this.uploaded.forEach(val => {
      if (val?.claimBenefitType) {
        if (this.claimBenefitTypes.filter(list => list['name'] === val['claimBenefitType']).length === 0) {
          val['claimBenefitType'] = ""
        }
      }
    })
    this.supportLink = this.document.location.origin + `/supported/${this.cacheService.getCountry().toLowerCase()}/${this.cacheService.getLanguage().toLowerCase()}`;
    this.fileFormatMsg = FILEFORMATERRORMSG().replace('supportLink', this.supportLink);
  }

  decodeClaimType(val) {

    if (val === 'injury') {
      return 'I';
    } else if (val === 'Personal Effects') {
      return 'P';

    } else if (val === 'Illness') {
      return 'I';
    }

  }

  /* lifecycle hooks */
  ngOnInit(): void {
    this.uploadSizeCount = this._dataStoreService.getuploadAllFileSize();
    this.country = this.cacheService.getCountry().toLowerCase();
    this.isAlertVisible = alertVisible[this.country];

    this.dropDownLabel = $localize`:@@documents.docType:Document Type`;
    this.typePlaceholder = $localize`:@@documents.selectPlaceholder:Select Document Type`;

    this.messageError = "Document Type is mandatory";
    this.fnolService.continueClickEvent.subscribe((res) => {
      if (this.uploaded.length > 0) {
        this.fnolService.getUpdateDocTypeRequest(this.uploaded);
      }
      if (res && (res["stepNo"] === 5 || (this.country === FNOL_COUNTRY.LITE.countryCode && res["stepNo"] && res["stepNo"]["slNo"] === 4))
      ) {
        this.errorMessage = res["isContinueBtnClicked"];
        this.changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.uploadProgress);
  }

  /* methods */

  cancelFileEdit(file, editedNameVar, index): void {
    file.edit = !file.edit;
    editedNameVar.touched = false;
    editedNameVar.value = file.name;
    this.fileValueChanged(file, editedNameVar, index);
    setTimeout(() => {
      this.elRef.nativeElement.querySelector("#editButton-" + index).focus();
    });
  }

  cancelUpload(index): void {
    clearInterval(this.uploadProgress);
    this.uploaded.splice(index, 1);
    this.uploadFileProgress = 0;
    this.customEvent.next({
      status: "valid",
      value: { uploads: this.uploaded },
    });
  }

  checkStatus(index): void {
    if (
      this.uploaded.length < 1 &&
      this.uploadErrorsList.length < 1 &&
      this.uploadSelectedInitial.length < 1
    ) {
      this.fileLoading = false; // show dragndrop if 0 files listed
    }
    this.update();
  }

  deleteError(file): void {
    const rL = this.uploadErrorsList.length;
    for (let index = 0; index < rL; index++) {
      if (file === this.uploadErrorsList[index]) {
        this.uploadErrorsList.splice(index, 1); // delete row
        this.checkStatus(index);
      }
    }
  }

  deleteFile(file): void {
    this.uploadSumErrorSize = false;
    const rL = this.uploaded.length;
    for (let index = 0; index < rL; index++) {
      if (file === this.uploaded[index]) {
        this.fnolService
          .deleteDocRequest({
            claimNumber: this.fnolModelService.getClaimNumber() ? (new URLSearchParams(window.location.search).get('followup') ? this.cacheService.getFollowUpClaimNumber() : this.fnolModelService.getClaimNumber()) : this.item.ClaimDetails.claimNo,
            documentId: this.uploaded[index].docId.toString(),
          })
          .subscribe((res) => {
            if (res.responseCode === 200) {
              this.uploadFilesSizeDecCount(file.size)
              if (this.uploaded.length === 1) {
                this.messageEvent.emit('false');
              }
              this.uploaded.splice(index, 1); // delete row
              this.deleteFailedError = false;
              this.checkStatus(index);
              this.customEvent.next({
                status: "valid",
                value: { uploads: this.uploaded },
              });
              this.changeDetectorRef.detectChanges();
            } else {
              this.customEvent.next({
                status: "invalid",
                value: { uploads: this.uploaded },
              });
              this.changeDetectorRef.detectChanges();
            }
          });
      }
    }
    if (!this.uploaded.length) {
      this.errorMessage = false;
    }
  }

  editFileName(file, index): void {
    file.edited = file.name;
    file.edit = !file.edit;
    setTimeout(() => {
      this.elRef.nativeElement.querySelector("#editedName-" + index).select();
    });
  }

  getIcons(uploadSelected): void {
    for (const axisFile of uploadSelected) {
      const file = axisFile.file;

      let icon = axisFile.icon,
        img = false,
        uploadIcon = "";
      if (icon === undefined) {
        if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ) {
          icon = "xlsx";
        } else if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          icon = "docx";
        } else if (
          file.type ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation"
        ) {
          icon = "pptx";
        } else if (file.type.match("^audio/")) {
          icon = "music_note";
        } else if (file.type.match("^image/gif")) {
          icon = "image";
          img = true;
        } else if (file.type.match("^image/jpeg")) {
          icon = "jpg";
          img = true;
        } else if (file.type.match("^image/png")) {
          icon = "png";
          img = true;
        } else if (file.type.match("^image/")) {
          icon = "image";
        } else if (file.type.match("pdf")) {
          icon = "pdf";
        } else if (file.type.match("text/csv")) {
          icon = "csv";
        } else if (file.type.match("^video/")) {
          icon = "video";
        } else if (file.type.match("text") || file.type === undefined) {
          icon = "txt";
        } else if (file.name.match(".ppt$")) {
          icon = "ppt";
        } else if (file.name.match(".xls$")) {
          icon = "xls";
        } else {
          icon = "txt";
        }
      }

      switch (icon) {
        case "avi":
          uploadIcon = "video";
          break;
        case "doc":
        case "docx":
          uploadIcon = "doc";
          break;
        case "gif":
          img = true;
          uploadIcon = "image";
          break;
        case "flv":
          uploadIcon = "video";
          break;
        case "jpeg":
          img = true;
          uploadIcon = "jpg";
          break;
        case "m4a":
          uploadIcon = "video";
          break;
        case "mov":
          uploadIcon = "video";
          break;
        case "mp3":
          uploadIcon = "music_note";
          break;
        case "mp4":
          uploadIcon = "video";
          break;
        case "ogg":
          uploadIcon = "video";
          break;
        case "png":
          img = true;
          uploadIcon = "png";
          break;
        case "ppt":
        case "pptx":
          uploadIcon = "picture_as_ppt";
          break;
        case "txt":
          uploadIcon = "picture_as_doc";
          break;
        case "xls":
        case "xlsx":
          uploadIcon = "picture_as_xls";
          break;
        case "tif":
        case "tiff":
          uploadIcon = "image";
          break;
        case "webm":
        case "wmv":
          uploadIcon = "video";
          break;
        default:
          uploadIcon = icon;
          break;
      }
      axisFile.img = this.imagePreview ? img : false;
      axisFile.uploadIcon = uploadIcon;
    }

    return uploadSelected;
  }

  getNow(type): string {
    let value;
    const today = new Date();
    if (type === "date") {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      value =
        months[today.getMonth()] +
        " " +
        today.getDate() +
        ", " +
        today.getFullYear();
    } else {
      let hours = today.getHours();
      const minutesNum = today.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      const minutes =
        minutesNum < 10 ? "0" + minutesNum.toString() : minutesNum;
      value = hours.toString() + ":" + minutes.toString() + " " + ampm;
    }
    return value;
  }

  openModalEdit(modal, file): void {
    file.edited = file.name;
    file.editedUploadedBy = file.uploadedBy;
    this.fileToEdit = file;
    modal.open();
    this.update();
  }

  fileValueChanged(file, editedNameVar, index) {
    if (!editedNameVar.value.length) {
      this.uploadRenameEmpty[index] = true;
      this.fnolService.fileNameEmpty.next(true);
    } else {
      this.uploadRenameEmpty[index] = false;
      if (!this.uploadRenameEmpty.includes(true)) {
        this.fnolService.fileNameEmpty.next(false);
      }
    }
  }

  renameFile(file, editedNameVar, index): void {
    if (file.edited === "" && editedNameVar.value.length > 0) {
      file.name = editedNameVar.value
      file.edit = !file.edit;
      this.uploadRenameEmpty[index] = false;
      if (!this.uploadRenameEmpty.includes(true)) {
        this.fnolService.fileNameEmpty.next(false);
      }
    } else {
      if (editedNameVar.value.length > 0) {
        file.name = file.edited;
        file.edit = !file.edit;
      }
    }
    this.customEvent.next({
      status: "valid",
      value: { uploads: this.uploaded },
    });
  }

  saveFile(): void {
    this.fileToEdit.name = this.fileToEdit.edited;
    this.fileToEdit.uploadedBy = this.fileToEdit.editedUploadedBy;
  }

  trackByIndex(index: number): number {
    return index;
  }

  update(): void {
    this.changeDetectorRef.detectChanges();
  }

  modelChanged(event, ind) {
    this.uploaded.forEach((upload, index) => {
      if (ind === index) {
          upload.claimBenefitType = event.name;
          return upload.claimBenefitType;
      }
    });
    if (!this.item) {
      this.customEvent.next({ status: 'valid', value: { uploads: this.uploaded } });
    } else {
      this.fnolService.upload.next({ upload: this.uploaded })
    }
  }

  getFileContent(fileSrc): string {
    return fileSrc.changingThisBreaksApplicationSecurity.split(",")[1];
  }

  uploadFiles(uploadSelected, fileSize): void {
    this.fileUploadFailed = false;
    this.allSelectedFiles = fileSize;
    if (!this.item) {
      if (!this.fnolModelService.getClaimNumber()) {
        this.commonCdpLiteApiService
          .generateClaimNumber_cdp_lite(this.cacheService.getCountry())
          .subscribe((res) => {
            this.fnolService.setTransactionId(res["transactionId"]);
            this.doUpload(uploadSelected, fileSize);
          }, (err) => {
            this.fileUploadFailed = true;
            this.apiFailure = $localize`${DISPLAY_MESSAGES().list.API_FAILURE}`;
          })

      } else {
        this.doUpload(uploadSelected, fileSize);

      }
    } else {
      this.doUpload(uploadSelected, fileSize);

    }

  }

  doUpload(uploadSelected, fileSize) {
    if (uploadSelected && uploadSelected.length > 0) {
      const uploadSelectedFirst = [];
      uploadSelectedFirst[0] = uploadSelected[0];
      uploadSelected.shift();
      this.uploadSelectedInitial = uploadSelected;
      this.uploadFilesIncremental(uploadSelectedFirst, fileSize);
    }
  }

  uploadFilesIncremental(uploadSelected, fileSize): void {
    this.uploadSumErrorSize = false;
    this.uploadSucces.next(false);
    this.fileUploadFailed = false;
    this.zeroByteError = false;
    this.exceedSizeError = false;
    if(this.allSelectedFiles === 1){
      this.formatUnsupportedError = false;
    }
    let fileCount = 0;
    let processingCount = 0;
    // const resultsDelay = 1200;
    // const uploadErrors = 0;
    if (uploadSelected[0].file.size / (1024 * 1024) > 15) {
      this.exceedSizeError = true;
      this.exceedSizeErrorMsg = DISPLAY_MESSAGES().list.FILE_SIZE;
      this.changeDetectorRef.detectChanges();
      this.uploadFiles(this.uploadSelectedInitial, fileSize);
      return;
    }
    const uploadTiming = [0, 25, 25, 25, 25]; // 33, 33, 34
    this.uploadSelected = uploadSelected;
    this.uploadSizeCount += (uploadSelected[0].file.size) / (1024 * 1024);
    this._dataStoreService.setuploadAllFileSize(this.uploadSizeCount);
    if (this.uploadSizeCount > 15) {
      this.uploadSumErrorSize = true;
      this.uploadFilesSizeDecCount(uploadSelected[0].file.size)
      this.uploadSumErrorSizeMsg = DISPLAY_MESSAGES().list.UPLOAD_ALL_FILE_SIZE;

      this.changeDetectorRef.detectChanges();
      return
    }
    if (uploadSelected[0].file.size === 0) {
      this.zeroByteError = true;
      this.zeroByteErrorMsg = DISPLAY_MESSAGES().list.ZEROBYTE_ERROR;
      this.changeDetectorRef.detectChanges();
      this.uploadFiles(this.uploadSelectedInitial, fileSize);
      return;
    }

    if (
      (MARINE_FILE_ALLOWED_FORMAT.indexOf(this.getImgFormat(uploadSelected[0].file.name).toUpperCase()) <= -1)
    ) {
      this.formatUnsupportedError = true;
      this.formatUnsupportedErrorMsg = DISPLAY_MESSAGES().list.FILE_TYPE;
      this.changeDetectorRef.detectChanges();
      this.uploadFiles(this.uploadSelectedInitial, fileSize);
      this.uploadFilesSizeDecCount(uploadSelected[0].file.size);
      return;
    }
    this.getIcons(uploadSelected);
    for (const axisFile of uploadSelected) {
      if (axisFile.count !== undefined) {
        continue;
      }
      const period = axisFile.file.name.lastIndexOf('.')
      const reg = /[<>?\\//:|*‘’“”"']{1,}/gi;
      const removeSpecialCharSubString = axisFile.file.name.substring(0, period).replace(reg, '_');
      const fileExtension = axisFile.file.name.substring(period + 1);
      const fileNameWithoutSpecial = removeSpecialCharSubString + '.' + fileExtension

      const uploadDocumentReqModelSG = {
        userId: AppConfig.userEmailID,
        documentId: "",
        country: this.cacheService.getCountry().toUpperCase(),
        dateofIncident: moment(this.cdpLiteModelService.getLossDocDate()).format("YYYY-MM-DD"),
        // dateofIncident:URL_PARAMETERS.COUNTRY.toLowerCase() === FNOL_COUNTRY.SINGAPORENEW.countryCode? this.fnolSgModelService.getDetail('dateOfAccident', 'doc'):'',
        claimNumber: this.fnolModelService.getClaimNumber(),
        policyNumber: this._dataStoreService.get("fnol-claimant-info").uiData['policyNumber'] ? this._dataStoreService.get("fnol-claimant-info").uiData['policyNumber'] : "NOPOLICY",
        documentSize: axisFile.file.size,
        documentMimeType: this.getImgFormat(axisFile.file.name),
        //  content: this.getFileContent(axisFile.src),
        documentName: fileNameWithoutSpecial,
        documentClassification: "PNC",
        documentClassificationName: "",
        documentNotes: "",
        documentVisibilityInd: "",
        documentStatusCd: "New",
        vendorID: "AIG",
        insuredName: "",
        batchName: CommonUtils.getBatchName(),
        branchCase: "REF:" + new URLSearchParams(window.location.search).get('followup') ? this.cacheService.getFollowUpClaimNumber() : this.fnolModelService.getClaimNumber() + "O",
        Origin: "O",
        subFolder: "FNOL",
        vendorDocType: "FNOL",
        cmDocType: "FNOL - Internet Report",
        receivedFrom: "Claims Digital Portal",
      };
      this.uploadDocumentModel = uploadDocumentReqModelSG;
      //  }
      axisFile.count = fileCount;
      axisFile.failed = false;
      axisFile.uploadFileProgress = 0;
      axisFile.timing = uploadTiming;

      this.fileLoading = true;
      this.update();

      this.loadingService.start($localize`:@@documents.loading:Files uploading...`);
      this.fileUploadFailed = false;

      axisFile.clearVisible = false;

      const dateSubmittedDisplay = this.getNow("date");
      const dateSubmittedTime = this.getNow("time");
      const data = new FormData();
      data.append(
        "uploadDocRequest",
        JSON.stringify(this.uploadDocumentModel)
      );
      data.append("uploadFile", axisFile.file);

      this.fnolService.docUploadRequest(data).subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.messageEvent.emit('true');
            this.uploadSucces.emit(true)
            this.fnolService.logErrorAEM(
              "docupload-success",
              data,
              response,
              "docUpload"
            );
            this.docIdGenerated = response.response["documentId"];

            const newUpload = {
              claimNo: new URLSearchParams(window.location.search).get('followup') ? this.cacheService.getFollowUpClaimNumber() : this.fnolModelService.getClaimNumber(),
              docId: this.docIdGenerated,
              claimBenefitType: "",
              active: true,
              checked: false,
              edit: false,
              img: axisFile.img,
              name: fileNameWithoutSpecial,
              newHighlight: true,
              size: axisFile.file.size,
              src: axisFile.src,
              status: "Success",
              type: axisFile.file.type,
              uploadDate: dateSubmittedDisplay,
              uploadDateTime: dateSubmittedTime,
              uploadedBy: this.userName,
              uploadIcon: axisFile.uploadIcon,
              uploadReqObj: uploadDocumentReqModelSG,
            };
            this.loadingService.stop();
            this.uploaded.push(newUpload);
            if (!this.item) {
              this.customEvent.next({
                status: "valid",
                value: { uploads: this.uploaded },
              });
            }

            axisFile.progressVisible = false;
            this.update();
            setTimeout(() => {
              newUpload.newHighlight = false;
              this.update();
            },);
          } else {
            this.fnolService.logErrorAEM(
              "docupload-not-2000",
              data,
              response,
              "docUpload"
            );
            this.loadingService.stop();
            this.uploadFilesSizeDecCount(uploadSelected[0].file.size);
            const newError = {
              active: true,
              errorHighlight: true,
              name: axisFile.file.name,
              reload: uploadSelected,
              status: "Failed",
              uploadIcon: axisFile.uploadIcon,
            };
            this.fileUploadFailed = true;
            this.apiFailure = DISPLAY_MESSAGES().list.API_FAILURE;
            this.changeDetectorRef.detectChanges();
            this.uploadErrorsList.push(newError);
            this.customEvent.next({
              status: "invalid",
              value: {
                uploads: this.uploaded,
                uploadError: this.uploadErrorsList,
              },
            });
            axisFile.progressVisible = false;
            this.update();
          }
        },
        (err) => {
          this.fnolService.logErrorAEM(
            "docupload-failure",
            data,
            err,
            "docUpload"
          );
          this.loadingService.stop();
          this.uploadFilesSizeDecCount(uploadSelected[0].file.size)
          this.apiFailure = DISPLAY_MESSAGES().list.API_FAILURE;
          this.fileUploadFailed = true;
          this.changeDetectorRef.detectChanges();
        }
      );

      processingCount++;

      this.update();
      this.uploadFiles(this.uploadSelectedInitial, fileSize);

      fileCount++;
    }
  }

  getImgFormat(fileFormat: string): string {
    return fileFormat.substring(fileFormat.lastIndexOf(".") + 1).toLowerCase();
  }

  getBatchname(): string {

    return moment().format("[AIG] MM[/]DD[/]YY h:mm:ssA");
  }
  uploadFilesSizeDecCount(size) {
    this.uploadSizeCount = this.uploadSizeCount - (size) / (1024 * 1024);
    this._dataStoreService.setuploadAllFileSize(this.uploadSizeCount);
  }
}
